import { useCallback, useContext } from 'react'

import { context } from '../context'
import { setServices } from '../actions'
import { useSelectors } from './selectors/use-selectors'
import { actions, AnalyticsService, categories } from '../../services/analytics'

// Toggle an extra on/off, honouring the service's `excludes` (mutually
// exclusive extras) and recomputing which extras the chosen base wash
// already `includes`. Shared by the Extras step and the Book & pay chips so
// both arms of the booking-flow experiment select extras identically.
export const useToggleExtra = () => {
  const { dispatch } = useContext(context)
  const { baseService, prices, services } = useSelectors()

  return useCallback(
    (serviceId, featured) => {
      const extraService = prices.byId[serviceId]
      if (!extraService) return

      // featured: true|false from Book & pay's chips (a featured chip or one
      // from "See all extras"); absent from every other caller.
      const on = services[serviceId]
      const tag = featured === undefined ? undefined : { featured: !!featured }
      AnalyticsService.trackEvent(categories.booking, on ? actions.desetlectExtraService : actions.setlectExtraService, extraService.name, extraService.price.format().replace('£', ''), tag)
      AnalyticsService[on ? 'trackRemoveFromCart' : 'trackAddToCart'](extraService, tag)

      const selectedServices = {
        ...services,
        ...(extraService.excludes || []).reduce((acc, id) => ({ ...acc, [id]: false }), {}),
        [serviceId]: !services[serviceId]
      }

      const newAvailability = Object.values(prices.byId).reduce(
        (acc, service) => ({
          ...acc,
          [service.id]: !((baseService?.includes || []).includes(service.id) || (extraService.includes || []).includes(service.id))
        }),
        {}
      )

      dispatch(setServices({ services: selectedServices, servicesAvailability: newAvailability }))
    },
    [baseService, dispatch, prices.byId, services]
  )
}
